import { Spinner } from '@/components/ui/spinner'
import { Text } from '@/components/ui/text'
import AnimatedBackground from '@components/AnimatedBackground'
import { css } from 'styled-system/css'

export default function Callback() {
  return (
    <main
      class={css({
        display: 'grid',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100vw',
        position: 'relative',
        overflow: 'hidden',
        isolation: 'isolate',
        bg: 'white',
      })}
    >
      <AnimatedBackground />
      <div class={css({ zIndex: 1, textAlign: 'center' })}>
        <Text textStyle="lg" fontWeight="medium">
          Authenticating...
        </Text>
        <Spinner />
      </div>
    </main>
  )
}
